import * as React from 'react';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';

import { useManagerNotificationsStore, useRootStore } from 'stores';

import { getTabTitleCounter } from './getTabTitleCounter';

/**
 * Индикатор непрочитанного в заголовке вкладки.
 *
 * Через titleTemplate, а не записью в document.title: заголовками владеет Helmet
 * (компонент Seo на страницах) и перетирает любую императивную запись при переходе
 * между разделами. titleTemplate — штатный способ, которым родитель дополняет
 * заголовок, объявленный страницей.
 */
const TabTitle: React.FC = () => {
  const rootStore = useRootStore();
  const managerNotificationsStore = useManagerNotificationsStore();

  // читаем lng, чтобы пересобрать заголовок при смене языка
  const { t } = rootStore.translationsStore.localization;

  const counter = getTabTitleCounter(t, {
    unreadConversationsCount:
      managerNotificationsStore.unreadConversationsCount.value,
    noteMentionsCount: managerNotificationsStore.noteMentionsCount.value,
    slaViolationsCount: managerNotificationsStore.slaViolationsCount,
    slaWarningsCount: managerNotificationsStore.slaWarningsCount
  });

  return (
    <Helmet
      titleTemplate={counter ? `${counter} — %s` : '%s'}
      defaultTitle={counter ?? undefined}
    />
  );
};

export default observer(TabTitle);
